import _ from 'lodash';
import {
  FETCH_ACCOUTINGPERIODS,
  PUSH_ACCOUTINGPERIODS,
  REMOVE_ACCOUTINGPERIODS,
  UPDATE_ACCOUTINGPERIODS,
  UPDATE_MODE,
  UPDATE_ACTIVE_ID } from '../actions/actions-accountingperiods';

const INITIAL_STATE = {
  accountingperiods: [],
  mode: 'index',
  activeId: '',
  activeAccountingperiods:{}
}


export default function(state = INITIAL_STATE, action){
  switch(action.type){
    case FETCH_ACCOUTINGPERIODS:
      return {
        ...state,
        accountingperiods:action.payload,
      }
    case PUSH_ACCOUTINGPERIODS:
      return {
        ...state,
        accountingperiods:[action.payload, ...state.accountingperiods],
      }
    case REMOVE_ACCOUTINGPERIODS:
      return {
        ...state,
        accountingperiods : [...state.accountingperiods.filter( (item) => item._id !== action.payload._id)]
      }
    case UPDATE_ACCOUTINGPERIODS:
      let index =  _.findIndex(state.accountingperiods, { '_id': action.payload._id })
      state.accountingperiods.splice(index, 1, action.payload)
      return {
        ...state,
        accountingperiods : state.accountingperiods
      }
    case UPDATE_MODE:
      return {
        ...state,
        mode : action.payload,
        activeId:''
      }
    case UPDATE_ACTIVE_ID:
      return {
        ...state,
        mode : action.mode,
        activeId:action.id,
        activeAccountingperiods: _.pick(_.find(state.accountingperiods, { '_id': action.id }), ['name', 'description', 'unit', 'categories','amount','minutePerSession','startTime','maxSessionPerday', '_id'])
      }
    default:
      return state

  }
}
